import { CustomAxiosHeaders } from '../config/services'
import config from '../config'
import { requests } from '.'
import firebase from 'firebase/compat/app'

// use serviceName value below as key in `versions` object in `src/config/services.ts` for developer versions
const serviceName = 'SurveyServices'
const opts: CustomAxiosHeaders = { serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

interface GetSurveyParams {
  locationId: string
  skip?: number
  limit: number
  query?: string
}

interface LocationIdParams {
  locationId: string
}

interface UpdateSurvey {
  name?: string
  id: string
  formData?: object
}
interface SurveysList {
  surveyIds: string
}

interface ExportSubmissionsParams {
  surveyIds: string[]
  startDate: string
  endDate: string
  locationId: string
  companyId: string
  type: string
}

interface SubmissionsCountParams {
  locationId: string;
  startAt: string;
  endAt: string;
}

const SurveysServices = {
  getSurveysByLocationId: (params: GetSurveyParams) =>
    request().get('/surveys/', { params }),
  getCountByLocationId: (params: LocationIdParams) =>
    request().get('/surveys/count', { params }),
  getById: (id: string) =>
    request().get(`/surveys/${id}`),
  getListByIds:(params: SurveysList) =>
    request().get(`/surveys/surveys-list`,{ params }),
  updateSurvey: (params: UpdateSurvey) =>
    request().post(`/surveys/${params.id}`, {
      name: params.name,
      formData: params.formData,
    }),
  scheduleExportSurvey: (params: ExportSubmissionsParams) =>
    request().post('/surveys/schedule-survey-export', params),
  getSubmissionsCount: (params: SubmissionsCountParams) =>
    request().get('/surveys/submissions-count', { params }),

  getSurveysByLocationIdV1: async (locationId: string, internalChannel: string) => {
    const firebaseToken = await firebase?.auth()?.currentUser?.getIdToken()
    const headers = {
      "location-id": locationId,
      "internal-channel": internalChannel,
      'token-id': firebaseToken,
    }
    return request({ headers, host: config.surveysApiUrl, skipInterceptor: true}).get('/v1/surveys')
  },
  getSubmissionById: (locationId: string, submissionId: string) =>
    request().get(`/surveys/submission/${submissionId}`, { params: { locationId }})
}

export default SurveysServices
